import React from "react";

const YoutubeToolSetup = ({
  onTranscribe,
  onSummarize,
  isProcessing = false,
  // YouTube settings props from parent
  activeTab = "summarize",
  summaryType = "short",
  language = "English",
  tone = "concise",
  onActiveTabChange,
  onSummaryTypeChange,
  onLanguageChange,
  onToneChange,
}) => {
  const summaryTypes = [
    { value: "short", label: "Short Summary" },
    { value: "medium", label: "Medium Summary" },
    { value: "long", label: "Long Summary" },
    { value: "bullets", label: "Bullet Points" },
    { value: "chapters", label: "Chapter Breakdown" },
  ];

  const languages = [
    "English",
    "Spanish",
    "French",
    "German",
    "Italian",
    "Portuguese",
    "Russian",
    "Japanese",
    "Korean",
    "Chinese",
    "Arabic",
    "Hindi",
  ];

  const tones = [
    { value: "concise", label: "Concise" },
    { value: "friendly", label: "Friendly" },
    { value: "technical", label: "Technical" },
  ];

  const handleTabChange = (tab) => {
    onActiveTabChange?.(tab);
  };

  return (
    <div className="h-full flex flex-col bg-bg-50">
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-6 scrollbar-thin">
        {/* Mode Tabs */}
        <div className="flex p-[2px] rounded-full bg-bg-60">
          <button
            onClick={() => handleTabChange("summarize")}
            className={`flex-1 px-3 py-2 text-sm font-medium rounded-full transition-colors ${
              activeTab === "summarize"
                ? "bg-ac-02 text-white dark:text-black/70 shadow-sm"
                : "text-fg-60 hover:text-fg-50 hover:bg-bg-40"
            }`}
          >
            Summarize
          </button>
          <button
            onClick={() => handleTabChange("transcribe")}
            className={`flex-1 px-3 py-2 text-sm font-medium rounded-full transition-colors ${
              activeTab === "transcribe"
                ? "bg-ac-02 text-white dark:text-black/70 shadow-sm"
                : "text-fg-60 hover:text-fg-50 hover:bg-bg-40"
            }`}
          >
            Transcribe
          </button>
        </div>

        {/* Summary Configuration - Only show when summarize tab is active */}
        {activeTab === "summarize" && (
          <div className="space-y-4">
            {/* Summary Type */}
            <div className="space-y-3">
              <label className="text-sm font-medium text-fg-50">
                Summary Type
              </label>
              <div className="space-y-2">
                {summaryTypes.map((type) => (
                  <label
                    key={type.value}
                    className="flex items-center gap-3 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="summaryType"
                      value={type.value}
                      checked={summaryType === type.value}
                      onChange={(e) => onSummaryTypeChange?.(e.target.value)}
                      className="text-ac-02 focus:ring-ac-02"
                    />
                    <span className="text-sm text-fg-50">{type.label}</span>
                  </label>
                ))}
              </div>
            </div>

            {/* Language Selection */}
            <div className="space-y-3">
              <label className="text-sm font-medium text-fg-50">Language</label>
              <select
                value={language}
                onChange={(e) => onLanguageChange?.(e.target.value)}
                className="w-full p-3 bg-bg-60 rounded-lg text-sm text-fg-50 focus:outline-none focus:ring-2 focus:ring-ac-02"
              >
                {languages.map((lang) => (
                  <option key={lang} value={lang}>
                    {lang}
                  </option>
                ))}
              </select>
            </div>

            {/* Tone Tabs */}
            <div className="space-y-3">
              <label className="text-sm font-medium text-fg-50">Tone</label>
              <div className="flex p-[2px] rounded-full bg-bg-60">
                {tones.map((toneOption) => (
                  <button
                    key={toneOption.value}
                    onClick={() => onToneChange?.(toneOption.value)}
                    className={`flex-1 px-3 py-2 text-sm font-medium rounded-full transition-colors ${
                      tone === toneOption.value
                        ? "bg-ac-02 text-white dark:text-black/70 shadow-sm"
                        : "text-fg-60 hover:text-fg-50 hover:bg-bg-40"
                    }`}
                  >
                    {toneOption.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* Processing Status */}
        {isProcessing && (
          <div className="bg-bg-50 rounded-lg p-4 border border-bd-50">
            <div className="flex items-center gap-3">
              <div className="w-5 h-5 border-2 border-ac-02 border-t-transparent rounded-full animate-spin"></div>
              <div className="text-sm text-fg-50">
                {activeTab === "transcribe"
                  ? "Transcribing video..."
                  : "Generating summary..."}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default YoutubeToolSetup;
